import React from 'react'
import './InstructionsModal.css'
import { connect } from 'react-redux'
import { SUBMIT_TEST, HIDE_TIMER } from '../../constants/actionTypes'
import PopUpWrapper from '../PopUpWrapper/PopUpWrapper'
import matrixInstruction from '../../assets/matrixQueLg.png'
import { useTranslation } from 'react-i18next'
const mapStateToProps = (state) => {
    return {
        ...state.testpanel,
        time: state.timer,
        usertestid: state.testStatus,
        testData: state.testpanel,
        completion: state.completion,
        ...state,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        onSubmitTest: (payload) => dispatch({ type: SUBMIT_TEST, payload }),
        hideTimer: (payload) => dispatch({ type: HIDE_TIMER, payload }),
    }
}

const InstructionsModal = (props) => {
    const { show, multiple, single, scmq, matrix, numerical } = props
    const { t, i18n } = useTranslation()

    const matrixQuestionInstruction = () => {
        return (
            <div style={{ display: 'flex', flexDirection: 'column' }}>
                <p>
                    {t('Matrix_Instructions')}
                    <b>{t('One or More')}</b>
                    {t('entries in Column II.')}
                </p>
                <img
                    src={matrixInstruction}
                    style={{ height: '262px', width: '430px' }}
                />
            </div>
        )
    }
    const singleQuestionInstruction = () => {
        return (
            <>
                {t('SingleChoice_Instructions')}
                <b>{t('ONLY ONE')}</b>
                {t('is correct.')}
            </>
        )
    }
    const multipleQuestionInstruction = () => {
        return (
            <>
                {t('MultipleChoice_Instructions')}
                <b>{t('MORE THAN ONE')}</b>
                {t('can be correct.')}
            </>
        )
    }
    return (
        show && (
            <PopUpWrapper>
                <div className="instruction-modal-wrapper">
                    <div className="instructions-modal-header">
                        <div className="instruction-modal-header-title">
                            {t('Question Instruction')}
                        </div>
                        <div className="read-carefully">
                            {t('Please read the instructions carefully')}
                        </div>
                    </div>
                    <dl>
                        <dt className="question-type">
                            {t(
                                single
                                    ? 'Single Answer Choice'
                                    : multiple
                                    ? 'Multiple Answer Choice'
                                    : matrix
                                    ? 'Matrix Type Question'
                                    : '',
                            )}
                        </dt>
                        <dd style={{ display: 'flex' }}>
                            <span className="instruction-modal-content">
                                {single
                                    ? singleQuestionInstruction()
                                    : multiple
                                    ? multipleQuestionInstruction()
                                    : matrix
                                    ? matrixQuestionInstruction()
                                    : ''}
                            </span>
                        </dd>
                    </dl>
                </div>
            </PopUpWrapper>
        )
    )
}
export default connect(mapStateToProps, mapDispatchToProps)(InstructionsModal)
